import React, { Fragment, useEffect, useState } from "react";
import Select, { components } from "react-select";
import {
    Button,
    Card,
    CardBody,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from "reactstrap";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import ServiceDetails from './serviceDetails';
import WindowTint from './windowTint';

import moment from "moment";
import 'react-phone-input-2/lib/style.css';
import { useSelector } from "react-redux";
import { firestore } from '../../../../helpers/Firebase';
const CustomSelectInput = props => {
    var customProps = Object.assign({}, props);
    delete customProps.autoCorrect;
    delete customProps.autoCapitalize;
    return <components.Input {...customProps} />;
};
let options = []
let startDuration = '00:15';
for (var i = 0; i < 26; i++) {
    var obj = { label: startDuration, value: startDuration, key: i + 1 };
    startDuration = moment(startDuration, 'HH:mm').add('15', 'minutes').format('HH:mm');
    options.push(obj);
}

const Services = ({ selectedOutlet, update, activeServices, servicesDescs, selectedProvider }) => {
    const { services, advServices, variations } = useSelector(state => state.providers);
    const [modifiers, setModifiers] = useState({});
    const [servicesCat, setServicesCat] = useState({});
    const [selectedServiceCat, setSelectedServiceCat] = useState(null);
    const [allActiveServices, setAllActiveServices] = useState([]);
    const [customService, setCustomService] = useState(null);
    const [deleteModal, setDeleteModal] = useState({ isOpen: false, service: null });

    // Helper function to check if service is configured
    const isServiceConfigured = (serviceKey) => {
        const serviceData = activeServices[serviceKey];
        if (!serviceData || Object.keys(serviceData).length === 0) {
            return false;
        }
        // Check if at least one modifier has price and duration configured
        return Object.keys(serviceData).some(modifierKey => {
            const modifier = serviceData[modifierKey];
            return modifier && (
                (modifier.price && modifier.duration) ||
                (modifier.waterlessPrice && modifier.waterlessDuration) ||
                (modifier.steamWashPrice && modifier.steamWashDuration) ||
                (typeof modifier === 'string' && modifier.length > 0) // For recovery type
            );
        });
    };

    // Helper function to get modifier count
    const getModifierCount = (serviceKey) => {
        const serviceData = activeServices[serviceKey];
        if (!serviceData) return 0;
        return Object.keys(serviceData).length;
    };

    // Helper function to check if a service is PPF
    const isPPFService = (service) => {
        return service?.type?.toLowerCase() === 'ppf';
    };

    // Helper function to create modifier display
    const createModifierDisplay = (modifier, item, index) => {
        const isRecovery = services[item]?.type === 'recovery';

        if (isRecovery) {
            return (
                <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <div style={{ marginRight: '8px', textTransform: 'capitalize' }}>
                        {modifier}
                    </div>
                    <div>"{activeServices?.[item]?.[modifier]}"</div>
                    <br />
                </div>
            );
        }

        const modifierData = [
            { key: 'price', title: 'Price' },
            { key: 'duration', title: 'Duration' },
            { key: 'waterlessPrice', title: 'Waterless Price' },
            { key: 'waterlessDuration', title: 'Waterless Duration' },
            { key: 'steamWashPrice', title: 'Steam Wash Price' },
            { key: 'steamWashDuration', title: 'Steam Wash Duration' },
        ];

        const modifierInfo = modifierData
            .map(rec => {
                const value = activeServices?.[item]?.[modifier]?.[rec?.key];
                return value ? `${rec?.title}: ${value}` : null;
            })
            .filter(Boolean)
            .join(', ');

        return (
            <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                <div style={{ marginRight: '8px' }}>
                    {modifiers[modifier]?.name}
                </div>
                <div>{modifierInfo}</div>
                <br />
            </div>
        );
    };


    // Helper function to process advanced services (window tint and PPF) for a specific selected service
    const processAdvancedServices = (selectedServiceKey) => {
        if (!selectedServiceKey) return [];

        const advancedServices = [];

        // Check if onsite services are disabled for this SP
        const isOnsiteEnabled = selectedProvider?.onsiteServicesEnabled; // Default to true if not set

        // Only process the selected service, not all active services
        const advService = advServices[selectedServiceKey];
        const regularService = services[selectedServiceKey];
        const service = advService || regularService;

        if (!service) return [];

        // Filter out onsite services if disabled
        if (service?.type === 'onSiteWash' && !isOnsiteEnabled) {
            return []; // Skip this service
        }

        // Process window tint (from advServices) and PPF (from regular services or advServices)
        const isPPF = isPPFService(service);
        const isWindowTint = advService && !isPPF; // Window tint is only from advServices

        // Filter out PPF services if disabled
        const isPPFEnabled = selectedProvider?.ppfServicesEnabled;
        if (isPPF && !isPPFEnabled) {
            return []; // Skip this service
        }

        // Only process if it's a window tint or PPF service
        if (isPPF || isWindowTint) {
            // Get active modifiers only for the selected service
            const serviceActiveModifiers = activeServices[selectedServiceKey] || {};

            Object.keys(serviceActiveModifiers).forEach(modifier => {
                if (modifiers[modifier]) {
                    advancedServices.push({
                        ...modifiers[modifier],
                        price: serviceActiveModifiers[modifier].price,
                        duration: serviceActiveModifiers[modifier].duration,
                        capacity: serviceActiveModifiers[modifier].capacity || '',
                        variations: serviceActiveModifiers[modifier].variations,
                        serviceType: isPPF ? 'ppf' : 'windowTint' // Preserve service type using helper
                    });
                }
            });
        }

        return advancedServices;
    };

    // Fetch modifiers from Firebase
    useEffect(() => {
        let modifiersData = {};
        firestore().collection('modifiers').get().then(function (snapshot) {
            snapshot.forEach(function (doc) {
                let modifier = {};
                modifier = doc.data();
                modifier.key = doc.id;
                modifier.price = '100';
                modifier.duration = '00:15';
                modifier.value = doc.data().name;
                modifier.label = doc.data().name;
                modifiersData[doc.id] = modifier;
            });
            setModifiers(modifiersData);
        });
    }, []);

    // Get all available services (both regular and advanced) that are active for this washer
    useEffect(() => {
        const allAvailableServices = [];

        // Add regular services (excluding PPF which should be handled as advanced)
        Object.keys(activeServices || {}).forEach(serviceKey => {
            if (services[serviceKey]) {
                const service = services[serviceKey];
                // Filter out onsite services if disabled
                const isOnsiteEnabled = selectedProvider?.onsiteServicesEnabled;
                if (service?.type === 'onSiteWash' && !isOnsiteEnabled) {
                    return;
                }
                // Filter out PPF services if disabled
                const isPPF = isPPFService(service);
                const isPPFEnabled = selectedProvider?.ppfServicesEnabled
                if (isPPF && !isPPFEnabled) {
                    return;
                }
                // PPF services should be treated as advanced even though they're in regular services
                allAvailableServices.push({
                    ...service,
                    isAdvanced: isPPF, // PPF services are treated as advanced
                    category: isPPF ? 'advanced' : 'regular'
                });
            }
        });

        // Add advanced services (window tint)
        Object.keys(activeServices || {}).forEach(serviceKey => {
            if (advServices[serviceKey]) {
                const service = advServices[serviceKey];
                // Filter out onsite services if disabled
                const isOnsiteEnabled = selectedProvider?.onsiteServicesEnabled;
                if (service?.type === 'onSiteWash' && !isOnsiteEnabled) {
                    return;
                }
                // Filter out PPF services if disabled
                const isPPF = isPPFService(service);
                const isPPFEnabled = selectedProvider?.ppfServicesEnabled;
                if (isPPF && !isPPFEnabled) {
                    return;
                }
                allAvailableServices.push({
                    ...service,
                    isAdvanced: true,
                    category: 'advanced'
                });
            }
        });

        // Sort services by index property (if it exists)
        allAvailableServices.sort((a, b) => {
            const indexA = a.index !== undefined ? a.index : Infinity;
            const indexB = b.index !== undefined ? b.index : Infinity;
            return indexA - indexB;
        });

        setServicesCat(allAvailableServices);

        // Set the first service as selected by default
        if (allAvailableServices.length > 0 && !selectedServiceCat) {
            setSelectedServiceCat(allAvailableServices[0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [services, advServices, activeServices, selectedProvider]);

    // Process services when selection changes
    useEffect(() => {
        if (!selectedServiceCat) return;

        let processedServices = [];

        // Check if this is a PPF service (can be from regular services) or advanced service (window tint)
        const isPPF = isPPFService(selectedServiceCat);

        if (selectedServiceCat.isAdvanced || isPPF) {
            // Advanced services (Window Tint from advServices) or PPF (from regular services)
            // Only process modifiers for the selected service, not all services
            processedServices = processAdvancedServices(selectedServiceCat.key);
            // Ensure the service type is preserved and include all service properties
            const serviceType = selectedServiceCat?.type?.toLowerCase();
            // PPF can be from regular services, window tint from advServices
            const fullService = isPPF
                ? (services[selectedServiceCat.key] || selectedServiceCat)
                : (advServices[selectedServiceCat.key] || selectedServiceCat);
            setCustomService({
                ...fullService, // Include all properties (brands, madeIn, warranty, heatLevels, tintLevels, tintingSides, etc.)
                ...selectedServiceCat, // Override with any selectedServiceCat properties
                type: serviceType || fullService?.type?.toLowerCase() || 'windowTint' // Preserve service type
            });
        } else {
            // Regular service (non-PPF) - only show the selected service
            const isOnsiteEnabled = selectedProvider?.onsiteServicesEnabled;
            if (services[selectedServiceCat.key]) {
                if (services[selectedServiceCat.key]?.type === 'onSiteWash' && !isOnsiteEnabled) {
                    return;
                }

                const service = {
                    ...services[selectedServiceCat.key],
                    serviceModifiers: services[selectedServiceCat.key].modifiers,
                    modifiers: Object.keys(activeServices[selectedServiceCat.key] || {}).map((modifier, index) =>
                        createModifierDisplay(modifier, selectedServiceCat.key, index)
                    )
                };
                processedServices = [service];
            }
        }

        setAllActiveServices(processedServices);
        // eslint-disable-next-line
    }, [activeServices, selectedServiceCat, services, advServices, modifiers, variations])

    const vatBanner = (() => {
        if (!selectedProvider?.vatRegistered) return null;
        const incl = !!selectedProvider?.pricesIncludeVat;
        const rate = 5;
        const bg = incl ? '#e8f5e9' : '#e3f2fd';
        const border = incl ? '#43a047' : '#1e88e5';
        const text = incl
            ? `This provider is VAT registered. Prices entered below already include ${rate}% VAT (VAT is extracted from the price and shown on the tax invoice).`
            : `This provider is VAT registered. Prices entered below exclude VAT — ${rate}% will be added on top at checkout and shown on the tax invoice.`;
        return (
            <div style={{ padding: '10px 14px', borderRadius: 8, background: bg, borderLeft: `4px solid ${border}`, fontSize: 13, color: '#333', display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 12 }}>
                <i className="simple-icon-info" style={{ fontSize: 16, marginTop: 2, color: border }} />
                <div>
                    <div>{text}</div>
                    <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>To change, edit VAT Details on the Provider profile.</div>
                </div>
            </div>
        );
    })();

    return (

        <Fragment>
            {vatBanner}
            <Row className='h-100'>
                <Colxx xxs="12" style={{ minHeight: '400px' }}>
                    <Row className='h-100' style={{ alignItems: 'stretch' }}>
                        <Colxx xxs="12" md="3" className="mb-4 mt-4" style={{ display: 'flex' }}>
                            <Card className="rounded h-100" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)', width: '100%', display: 'flex', flexDirection: 'column' }}>
                                <CardBody style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                                    <div style={{ marginBottom: '20px' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '5px' }}>
                                            <h4 style={{ margin: 0, fontWeight: '600', color: '#2c3e50', display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="simple-icon-list" style={{ color: '#3498db' }}></i>
                                                Services
                                            </h4>
                                            {servicesCat && servicesCat.length > 0 && (
                                                <div style={{
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    padding: '4px 10px',
                                                    borderRadius: '12px',
                                                    background: '#e3f2fd',
                                                    color: '#3498db',
                                                    fontSize: '12px',
                                                    fontWeight: '600'
                                                }}>
                                                    <i className="simple-icon-check" style={{ fontSize: '10px' }}></i>
                                                    {servicesCat.length} {servicesCat.length === 1 ? 'service' : 'services'}
                                                </div>
                                            )}
                                        </div>
                                        <p className="text-muted" style={{ fontSize: '12px', marginBottom: '8px' }}>
                                            Add and configure services
                                        </p>
                                    </div>

                                    {/* Select dropdown to add services */}
                                    <Select
                                        components={{ Input: CustomSelectInput }}
                                        className="react-select mb-3"
                                        name="form-field-name"
                                        placeholder={
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <i className="simple-icon-plus" style={{ fontSize: '14px' }}></i>
                                                <span>Add Service</span>
                                            </div>
                                        }
                                        value=""
                                        options={
                                            // Combine regular and advanced services, then sort by index
                                            [
                                                ...Object.values(services || {}).filter(item => {
                                                    // Filter out already active services
                                                    if (activeServices[item.key]) {
                                                        return false;
                                                    }
                                                    // Filter out onsite services if disabled for this SP
                                                    const isOnsiteEnabled = selectedProvider?.onsiteServicesEnabled;
                                                    if (item?.type === 'onSiteWash' && !isOnsiteEnabled) {
                                                        return false;
                                                    }
                                                    // Filter out PPF services if disabled for this SP
                                                    const isPPFEnabled = selectedProvider?.ppfServicesEnabled;
                                                    if (isPPFService(item) && !isPPFEnabled) {
                                                        return false;
                                                    }
                                                    // Filter out quick wash services if disabled for this SP
                                                    const isQuickWashEnabled = selectedProvider?.quickWashServicesEnabled;
                                                    if (item?.type === 'quickWash' && !isQuickWashEnabled) {
                                                        return false;
                                                    }
                                                    return true;
                                                }).map(s => {
                                                    const isPPF = isPPFService(s);
                                                    return {
                                                        ...s,
                                                        isAdvanced: isPPF, // PPF is treated as advanced
                                                        label: isPPF ? `${s.name} (Advanced)` : s.name,
                                                        value: s.name
                                                    };
                                                }),
                                                ...Object.values(advServices || {}).filter(item => {
                                                    // Filter out already active services
                                                    if (activeServices[item.key]) {
                                                        return false;
                                                    }
                                                    // Filter out onsite services if disabled for this SP
                                                    const isOnsiteEnabled = selectedProvider?.onsiteServicesEnabled;
                                                    if (item?.type === 'onSiteWash' && !isOnsiteEnabled) {
                                                        return false;
                                                    }
                                                    // Filter out PPF services if disabled for this SP
                                                    const isPPFEnabled = selectedProvider?.ppfServicesEnabled;
                                                    if (isPPFService(item) && !isPPFEnabled) {
                                                        return false;
                                                    }
                                                    // Filter out quick wash services if disabled for this SP
                                                    const isQuickWashEnabled = selectedProvider?.quickWashServicesEnabled;
                                                    if (item?.type === 'quickWash' && !isQuickWashEnabled) {
                                                        return false;
                                                    }
                                                    return true;
                                                }).map(s => ({ ...s, isAdvanced: true, label: `${s.name} (Advanced)`, value: s.name }))
                                            ].sort((a, b) => {
                                                const indexA = a.index !== undefined ? a.index : Infinity;
                                                const indexB = b.index !== undefined ? b.index : Infinity;
                                                return indexA - indexB;
                                            })
                                        }
                                        onChange={(val) => {
                                            // Add the service to activeServices
                                            activeServices[val.key] = {};
                                            update({ activeServices });
                                            // Auto-select the newly added service
                                            setSelectedServiceCat({ ...val, isAdvanced: val.isAdvanced, category: val.isAdvanced ? 'advanced' : 'regular' });
                                        }}
                                    />

                                    {/* List of active services */}
                                    {servicesCat && servicesCat.length > 0 ? (
                                        <div style={{ flex: 1, overflowY: 'auto', paddingRight: '5px', minHeight: 0 }}>
                                            {servicesCat.map((service) => {
                                                const isSelected = selectedServiceCat?.key === service.key;
                                                const isConfigured = isServiceConfigured(service.key);
                                                const modifierCount = getModifierCount(service.key);

                                                return (
                                                    <div
                                                        key={service.key}
                                                        id={service.key}
                                                        className='mt-2 mb-2'
                                                        style={{
                                                            borderRadius: "10px",
                                                            background: isSelected ? 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)' : '#ffffff',
                                                            color: isSelected ? '#fff' : '#333',
                                                            cursor: 'pointer',
                                                            transition: 'all 0.15s ease',
                                                            border: isSelected ? 'none' : '1px solid #e0e0e0',
                                                            boxShadow: isSelected ? '0 2px 6px rgba(52, 152, 219, 0.2)' : '0 1px 2px rgba(0,0,0,0.05)',
                                                            overflow: 'hidden'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (!isSelected) {
                                                                e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.08)';
                                                                e.currentTarget.style.transform = 'translateY(-1px)';
                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (!isSelected) {
                                                                e.currentTarget.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
                                                                e.currentTarget.style.transform = 'translateY(0)';
                                                            }
                                                        }}
                                                        onClick={() => {
                                                            setSelectedServiceCat(service);
                                                        }}
                                                    >
                                                        <div style={{ padding: '12px 15px' }}>
                                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
                                                                    <i
                                                                        className={service.isAdvanced ? "simple-icon-energy" : "simple-icon-wrench"}
                                                                        style={{
                                                                            fontSize: '18px',
                                                                            color: isSelected ? '#fff' : '#3498db'
                                                                        }}
                                                                    ></i>
                                                                    <div>
                                                                        <div style={{
                                                                            fontSize: '14px',
                                                                            fontWeight: '600',
                                                                            lineHeight: '1.3'
                                                                        }}>
                                                                            {service.name}
                                                                        </div>
                                                                        {modifierCount > 0 && (
                                                                            <div style={{
                                                                                fontSize: '11px',
                                                                                opacity: isSelected ? 0.9 : 0.6,
                                                                                marginTop: '2px'
                                                                            }}>
                                                                                {modifierCount} {modifierCount === 1 ? 'modifier' : 'modifiers'}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                    {isConfigured ? (
                                                                        <i
                                                                            className="simple-icon-check"
                                                                            style={{
                                                                                fontSize: '14px',
                                                                                color: isSelected ? '#fff' : '#28a745',
                                                                                background: isSelected ? 'rgba(255,255,255,0.2)' : '#e8f5e9',
                                                                                borderRadius: '50%',
                                                                                padding: '4px',
                                                                                width: '22px',
                                                                                height: '22px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center'
                                                                            }}
                                                                            title="Service is configured"
                                                                        ></i>
                                                                    ) : (
                                                                        <i
                                                                            className="simple-icon-exclamation"
                                                                            style={{
                                                                                fontSize: '14px',
                                                                                color: isSelected ? '#fff' : '#ff9800',
                                                                                background: isSelected ? 'rgba(255,255,255,0.2)' : '#fff3e0',
                                                                                borderRadius: '50%',
                                                                                padding: '4px',
                                                                                width: '22px',
                                                                                height: '22px',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center'
                                                                            }}
                                                                            title="Service needs configuration"
                                                                        ></i>
                                                                    )}
                                                                    {service.isAdvanced && (
                                                                        <span
                                                                            className="badge badge-pill"
                                                                            style={{
                                                                                background: isSelected ? 'rgba(255,255,255,0.25)' : isPPFService(service) ? '#9b59b6' : '#6c757d',
                                                                                color: isSelected ? '#fff' : '#fff',
                                                                                fontSize: '9px',
                                                                                padding: '3px 8px',
                                                                                fontWeight: '500'
                                                                            }}
                                                                        >
                                                                            {isPPFService(service) ? 'PPF' : 'Advanced'}
                                                                        </span>
                                                                    )}
                                                                    <i
                                                                        className="simple-icon-trash"
                                                                        style={{
                                                                            fontSize: '14px',
                                                                            color: isSelected ? '#fff' : '#dc3545',
                                                                            cursor: 'pointer',
                                                                            padding: '4px',
                                                                            borderRadius: '4px',
                                                                            transition: 'all 0.2s'
                                                                        }}
                                                                        onMouseEnter={(e) => {
                                                                            e.currentTarget.style.background = isSelected ? 'rgba(255,255,255,0.2)' : '#fee';
                                                                        }}
                                                                        onMouseLeave={(e) => {
                                                                            e.currentTarget.style.background = 'transparent';
                                                                        }}
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            setDeleteModal({ isOpen: true, service });
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ) : (
                                        <div className="text-center text-muted mt-4" style={{ padding: '40px 20px' }}>
                                            <i className="simple-icon-list" style={{ fontSize: '48px', color: '#e0e0e0', marginBottom: '15px', display: 'block' }}></i>
                                            <p style={{ fontSize: '14px', fontWeight: '500', marginBottom: '5px' }}>No active services</p>
                                            <p style={{ fontSize: '12px', color: '#999' }}>Use the dropdown above to add services</p>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                        </Colxx>

                        {/* Render ServiceDetails component for regular services */}
                        {selectedServiceCat && !selectedServiceCat.isAdvanced && !isPPFService(selectedServiceCat) && (
                            <Colxx xxs="12" md="9" className="mb-4 mt-4">
                                <ServiceDetails
                                    activeServices={activeServices}
                                    selectedProvider={selectedProvider}
                                    allActiveServices={allActiveServices}
                                    services={services}
                                    options={options}
                                    servicesDescs={servicesDescs}
                                    modifiers={modifiers}
                                    update={update}
                                    selectedService={selectedServiceCat}
                                />
                            </Colxx>
                        )}

                        {/* Render WindowTint component for advanced services (window tint and PPF) */}
                        {selectedServiceCat && (selectedServiceCat.isAdvanced || isPPFService(selectedServiceCat)) && (
                            <Colxx xxs="12" md="9" className="mb-4 mt-4">
                                <WindowTint
                                    selectedWasher={selectedOutlet}
                                    activeServices={activeServices}
                                    selectedProvider={selectedProvider}
                                    allActiveServices={allActiveServices}
                                    services={{ ...advServices, ...services }} // Include both advServices and regular services (for PPF)
                                    service={customService}
                                    variations={variations}
                                    servicesDescs={servicesDescs}
                                    modifiers={modifiers}
                                    options={options}
                                    update={update}
                                />
                            </Colxx>
                        )}

                    </Row>

                </Colxx>
            </Row>

            {/* Delete Confirmation Modal */}
            <Modal
                isOpen={deleteModal.isOpen}
                toggle={() => setDeleteModal({ isOpen: false, service: null })}
                backdrop="static"
            // centered
            >
                <ModalHeader toggle={() => setDeleteModal({ isOpen: false, service: null })}>
                    {/* <i className="simple-icon-exclamation" style={{ color: '#dc3545', marginRight: '10px' }}></i> */}
                    Remove Service
                </ModalHeader>
                <ModalBody>
                    <p>
                        Are you sure you want to remove <strong>{deleteModal.service?.name}</strong> from this worker's services?
                    </p>
                    <p style={{ fontSize: '13px', color: '#6c757d', marginTop: '10px' }}>
                        This action cannot be undone. All configured modifiers and settings for this service will be removed.
                    </p>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="secondary"
                        outline
                        onClick={() => setDeleteModal({ isOpen: false, service: null })}
                    >
                        Cancel
                    </Button>
                    <Button
                        color="danger"
                        onClick={() => {
                            const service = deleteModal.service;
                            // Remove service
                            delete activeServices[service.key];
                            update({ activeServices });
                            // If this was selected, select the first available service
                            if (selectedServiceCat?.key === service.key) {
                                const remainingServices = servicesCat.filter(s => s.key !== service.key);
                                if (remainingServices.length > 0) {
                                    setSelectedServiceCat(remainingServices[0]);
                                } else {
                                    setSelectedServiceCat(null);
                                }
                            }
                            setDeleteModal({ isOpen: false, service: null });
                        }}
                    >
                        <i className="simple-icon-trash" style={{ marginRight: '5px' }}></i>
                        Remove Service
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment >
    )
}




export default Services;

